export enum HTTP_STATUS_CODE {
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  SUCCESS = 200,
  INTERNAL_ERROR = 500
}
